export default __webpack_public_path__ + "static/media/esmp_banner.923040ee.jpg";